import { render, staticRenderFns } from "./follow-up-card.vue?vue&type=template&id=03cbe798&scoped=true"
import script from "./follow-up-card.vue?vue&type=script&lang=js"
export * from "./follow-up-card.vue?vue&type=script&lang=js"
import style0 from "./follow-up-card.vue?vue&type=style&index=0&id=03cbe798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cbe798",
  null
  
)

export default component.exports